import { getEnv } from '@suite/shared/getEnv';

export const environment = {
  production: true,
  auth: {
    clientId: 'flexClient',
    tenantId: 'Flex',
    get issuer() {
      const env = getEnv('env');
      const s = env === 'production' || env === 'prod' ? '' : `${env}.`;
      return `https://${s}auth.noova.no/realms/`;
    },
    redirectUri: '/callback',
  },
  get errorLevel() {
    return getEnv('env') === 'dev' ? 'warn' : 'none';
  },
  customLogin: true,
  showHoodColors: getEnv('env') !== 'prod',
};
